import z from 'zod';
export const unsignedTx = z.object({
    from: z.string(),
    chainId: z.string(),
    to: z.string(),
    value: z.string(),
    data: z.string(),
    gasLimit: z.number().optional(),
});
export const TRANSACTION_TYPES = [
    'send',
    'receive',
    'swap',
    'contract',
    'limitOrder',
    'stopLoss',
    'twap',
    'deposit',
    'withdraw',
    'approval',
];
export const TRANSACTION_STATUSES = ['success', 'failed'];
export function isSendTransaction(tx) {
    return tx.type === 'send';
}
export function isReceiveTransaction(tx) {
    return tx.type === 'receive';
}
export function isSwapTransaction(tx) {
    return tx.type === 'swap';
}
export function isContractTransaction(tx) {
    return tx.type === 'contract';
}
